<!-- SafeSend Deliverable - Non-expandable card with View button -->
<ng-container *ngIf="isSafeSendEnabled$ | async; else regularDeliverable">
  <div
    class="safesend-deliverable rounded-1 py-4 px-6 d-flex justify-content-between align-items-center"
    [ngClass]="{ 'deliverable-complete': isGroupComplete }"
    [dataSelector]="dataSelector + '-safesend-card'"
  >
    <div class="d-flex align-items-center gap-2">
      <h4 class="h4-500 color-gray-100" [dataSelector]="dataSelector + '-title'">{{ instance.name$ | async }}</h4>

      <pill
        [color]="instance.safeSendStatusColor$ | async"
        [value]="instance.safeSendStatus$ | async"
        [dark]="true"
        [dataSelector]="dataSelector + '-safesend-status-pill'"
      ></pill>
    </div>

    <div class="d-flex align-items-center gap-3">
      <app-avatar
        *ngIf="isMultiContactsEnabled$ | async"
        nameStyle="full"
        [avatarInput]="(instance.avatars$ | async) ?? []"
        [domain]="'contact'"
        [limit]="3"
        [showLabel]="false"
        [dataSelector]="dataSelector + '-avatars'"
      ></app-avatar>

      <button
        andButton
        color="secondary"
        size="small"
        [isLoading]="(isSafeSendViewLoading$ | async) ?? false"
        [dataSelector]="dataSelector + '-safesend-view-button'"
        (click)="viewSafeSendDeliverable()"
      >
        <aiwyn-icon namespace="custom" name="safe-send" [height]="16" [width]="16" class="me-1" stroke="transparent"></aiwyn-icon>
        View
      </button>
    </div>
  </div>
</ng-container>

<!-- Regular Deliverable - Expandable panel with download functionality -->
<ng-template #regularDeliverable>
  <mat-expansion-panel
    hideToggle
    class="rounded-1 py-4 px-6"
    [expanded]="focused$ | async"
    [ngClass]="{ 'deliverable-complete': isGroupComplete }"
    [dataSelector]="dataSelector + '-expansion-panel'"
  >
    <mat-expansion-panel-header class="p-0 justify-content-start">
      <mat-panel-title class="justify-content-between me-0">
        <div class="d-flex align-items-center gap-2">
          <aiwyn-icon name="chevron-right" class="icon-color-gray-500" [height]="16" [width]="16"></aiwyn-icon>

          <h4 class="h4-500 color-gray-100" [dataSelector]="dataSelector + '-title'">{{ instance.name$ | async }}</h4>

          <p *ngIf="fileCount$ | async as fileCount" class="body-400 color-gray-400" [dataSelector]="dataSelector + '-file-count'">
            {{ fileCount }} attached file{{ fileCount === 1 ? '' : 's' }}
          </p>
        </div>

        <div class="d-flex align-items-center gap-3">
          <app-avatar
            *ngIf="isMultiContactsEnabled$ | async"
            nameStyle="full"
            [avatarInput]="instance.avatars$ | async"
            [domain]="'contact'"
            [limit]="3"
            [showLabel]="false"
            [dataSelector]="dataSelector + '-avatars'"
          ></app-avatar>

          <button
            andButton
            color="ghost-secondary"
            size="small"
            [isLoading]="isDownloadAllFilesProcessing$ | async"
            [dataSelector]="dataSelector + '-download-all-button'"
            (click)="$event.stopPropagation() || downloadAllFiles()"
          >
            Download All Files
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <p class="body-300 color-gray-400 px-2 mb-4" [dataSelector]="dataSelector + '-description'">{{ instance.description$ | async }}</p>

    <ng-container *ngIf="{ value: fileIdsDownloading$ | async } as fileIdsDownloading">
      <div
        *ngFor="let file of instance.files$ | async; let index = index"
        class="d-flex align-items-center justify-content-between w-100 gap-2 py-1 px-2 deliverable-file"
        [ngClass]="{ 'border-0': index === 0 }"
        [dataSelector]="dataSelector + '-file-item-' + index"
      >
        <p class="body-300 color-gray-400" [dataSelector]="dataSelector + '-file-name-' + index">{{ file.name }}</p>

        <div class="d-flex" [dataSelector]="dataSelector + '-file-actions-' + index">
          <button
            andButton
            color="ghost"
            size="small"
            [dataSelector]="dataSelector + '-preview-button-' + index"
            (click)="previewFile(file)"
          >
            <aiwyn-icon name="eye" class="icon-color-gray-500" [height]="16" [width]="16"></aiwyn-icon>
          </button>

          <button
            andButton
            color="ghost"
            size="small"
            [isLoading]="!!fileIdsDownloading.value?.[file.id]"
            [dataSelector]="dataSelector + '-download-button-' + index"
            (click)="downloadFile(file)"
          >
            <aiwyn-icon name="download" class="icon-color-gray-500" [height]="16" [width]="16"></aiwyn-icon>
          </button>
        </div>
      </div>
    </ng-container>
  </mat-expansion-panel>
</ng-template>
